(function () {
  function pad(n) {
    return n < 10 ? "0" + n : "" + n;
  }

  function initShippingBlocks(root) {
    const scope = root || document;
    const blocks = scope.querySelectorAll(".custom-shipping-container");

    blocks.forEach((block) => {
      const timerEl = block.querySelector(".order-timer");
      const shipEl = block.querySelector(".shipping-date");
      if (!timerEl || !shipEl) return;

      // Ships: 3 days after today (client local time)
      const daysAfterToday = parseInt(block.dataset.shipDays || "3", 10);
      const today = new Date();
      const shipDate = new Date(today);
      shipDate.setDate(today.getDate() + daysAfterToday);
    //   shipEl.textContent = shipDate.toLocaleDateString("en-US", { weekday: "long" });
      shipEl.textContent = "Tomorrow";


      function updateTimer() {
        const now = new Date();
        const midnight = new Date();
        midnight.setHours(24, 0, 0, 0);

        const diff = midnight - now;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        timerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
      }

      updateTimer();

      // Prevent duplicate intervals when Shopify re-renders sections
      if (!block.dataset.timerStarted) {
        block.dataset.timerStarted = "1";
        setInterval(updateTimer, 1000);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => initShippingBlocks(document));
  document.addEventListener("shopify:section:load", (e) => initShippingBlocks(e.target));
})();
